// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

// Note: Has a dependancy on M.Model.ProductDetails constants
//

/*
  UMD header generated via modularize.js at 2015-04-02T17:20:55.138Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:constants': ['EnvelopeColorOption']
})(this, function (m_module, constants_module) {

var M = m_module.M;
var EnvelopeColorOption = constants_module.EnvelopeColorOption;

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

// PDP product photo views
M.View.ProductDetails.BACK_VIEW = 'back';
M.View.ProductDetails.FRAMED_VIEW_BLACK = 'framedBlack';
M.View.ProductDetails.FRAMED_VIEW_WHITE = 'framedWhite';
M.View.ProductDetails.FRAMED_VIEW_WOOD = 'framedWood';
M.View.ProductDetails.FRAMED_VIEW_BLACK_TIER2 = 'framedBlackTier2';
M.View.ProductDetails.FRAMED_VIEW_WHITE_TIER2 = 'framedWhiteTier2';

M.View.ProductDetails.FRAMED_VIEW_RECLAIMED_BARN = 'framedReclaimedBarn';
M.View.ProductDetails.FRAMED_VIEW_DISTRESSED_CHARCOAL = 'framedDistressedCharcoal';
M.View.ProductDetails.FRAMED_VIEW_DISTRESSED_WHITE = 'framedDistressedWhite';
M.View.ProductDetails.FRAMED_VIEW_DISTRESSED_INDIGO = 'framedDistressedIndigo';

M.View.ProductDetails.FRAMED_VIEW_HAND_CARVED_NATURAL = 'framedHandCarvedNatural';
M.View.ProductDetails.FRAMED_VIEW_HAND_CARVED_WHITE = 'framedHandCarvedWhite';
M.View.ProductDetails.FRAMED_VIEW_ARROWHEAD = 'framedArrowhead';
M.View.ProductDetails.FRAMED_VIEW_FILIGREE = 'framedFiligree';
M.View.ProductDetails.FRAMED_VIEW_BRUSHED_SILVER = 'framedBrushedSilver';
M.View.ProductDetails.FRAMED_VIEW_CHAMPAGNE_SILVER = 'framedChampagneSilver';
M.View.ProductDetails.FRAMED_VIEW_MATTE_COPPER = 'framedMatteCopper';
M.View.ProductDetails.FRAMED_VIEW_MATTE_BRASS = 'framedMatteBrass';
M.View.ProductDetails.FRAMED_VIEW_MATTE_BLACK = 'framedMatteBlack';
M.View.ProductDetails.FRAMED_VIEW_OVAL = 'framedOval';
M.View.ProductDetails.FRAMED_VIEW_GRAY = 'framedGray';
M.View.ProductDetails.FRAMED_VIEW_WALNUT = 'framedWalnut';
M.View.ProductDetails.FRAMED_VIEW_ESPRESSO = 'framedEspresso';
M.View.ProductDetails.FRAMED_VIEW_GILDED = 'framedGilded';

M.View.ProductDetails.FRONT_VIEW = 'front';
M.View.ProductDetails.INTERIOR_VIEW = 'interior';

// Binding Labels
M.View.ProductDetails.BINDING_OPTION_LABELS = {};
M.View.ProductDetails.BINDING_OPTION_LABELS[
  M.BindingOptions.SPIRAL] = 'Spiral Binding';
M.View.ProductDetails.BINDING_OPTION_LABELS[
  M.BindingOptions.GROMMETED] = 'Grommets';


// Format Captions
M.View.ProductDetails.FORMAT_CAPTIONS = {};
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.FLAT] = 'Photo and other backer options';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.FOLDED_BLANK] = 'Blank inside';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.FOLDED_TEXT] = 'Blank, photo, or text inside';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.YEARLINE] = 'Story or Yearline&trade; interior';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.BLANK_NOTEBOOK] = '40 pages, your choice of lined, blank or graph premium paper for notes and sketches.';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.LINED_NOTEBOOK] = '80 pages. Choose from lined, blank, or grid interiors for ' +
  'journaling, note-taking, sketching, and all your creative and organizational needs. ' +
  'Finished with chic rounded corners and a clear protective cover.';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.MONTHLY_PLANNER_NOTEBOOK] = '20 page slim planner, with undated month spreads and a two-year overview. ' +
  'Includes clear protective cover, paper pocket for bills and receipts, ' +
  'helpful stickers to mark important dates, and extra pages for notes.';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.WEEKLY_PLANNER_NOTEBOOK] = '50 pages, with undated week spreads and perforated corners to track which week you are on, ' +
  'plus 12 undated month spreads and a two-year overview. Includes clear protective cover, paper pocket for bills and receipts, ' +
  'helpful stickers to mark important dates, and extra lined pages for notes.';
M.View.ProductDetails.FORMAT_CAPTIONS[
  M.FormatOptions.ADDRESS_BOOK_NOTEBOOK] = 'Store your addresses in style with room for 480 entries. ' +
  'Each entry includes space for multiple phone numbers and an email address. ' +
  'Finished with A to Z tabs, chic rounded corners and clear protective covers.';

// Binding Captions
M.View.ProductDetails.BINDING_OPTION_CAPTIONS = {};
M.View.ProductDetails.BINDING_OPTION_CAPTIONS[
  M.BindingOptions.SPIRAL] =
  'Chic silver spirals with a clear protective cover on the front and back to protect from daily wear and tear.';
M.View.ProductDetails.BINDING_OPTION_CAPTIONS[
  M.BindingOptions.GROMMETED] = 'Hand-finished with grommets for a minimalist look. Only available on notebooks.';

// Placecard-specific format captions
M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS = {};
M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS[
  M.FormatOptions.FLAT] = 'A flat 3.5" x 2" card';
M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS[
  M.FormatOptions.FOLDED_BLANK] = 'A tented 3.5" x 4" card';
// Placecard format captions when they have guest name printing
M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS_GUEST_PRINTING = {};
M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS_GUEST_PRINTING[
  M.FormatOptions.FLAT] = 'A flat 3.5" x 2" card available ' +
                           'with FREE guest name printing or blank.';
M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS_GUEST_PRINTING[
  M.FormatOptions.FOLDED_BLANK] = 'A tented 3.5" x 4" card ' +
                           'available with FREE guest name printing or blank.';
// Table Number format captions when they have custom printing
M.View.ProductDetails.FORMAT_CAPTIONS_TABLE_NUMBER_PRINTING = {};
M.View.ProductDetails.FORMAT_CAPTIONS_TABLE_NUMBER_PRINTING[
  M.FormatOptions.FLAT] = 'A flat 5" x 7" card with FREE double-sided' +
                          ' custom text printing.';
M.View.ProductDetails.FORMAT_CAPTIONS_TABLE_NUMBER_PRINTING[
  M.FormatOptions.FOLDED_BLANK] = 'A tented 5" x 7" card with FREE ' +
                                  'double-sided custom text printing.';

// Envelope DOM IDs
M.View.ProductDetails.ENVELOPE_DOM_IDS = {};
// Envelope Display Names
M.View.ProductDetails.ENVELOPE_DISPLAY_NAMES = {};
// Envelope Captions
M.View.ProductDetails.ENVELOPE_CAPTIONS = {};

M.envelopeOptionMappingsService = function() {
  if (typeof M.ENVELOPE_OPTION_MAPPINGS !== 'undefined') {
    return M.ENVELOPE_OPTION_MAPPINGS;
  }
  return undefined;
};

var options = M.envelopeOptionMappingsService();
if (typeof options !== 'undefined') {
    $.each(options, function (key, option) {
        M.View.ProductDetails.ENVELOPE_DOM_IDS[option['envelope_option_index']] = option['envelope_color_dom_id'];
        M.View.ProductDetails.ENVELOPE_DISPLAY_NAMES[option['envelope_option_index']] = option['envelope_color_display_name'];
        M.View.ProductDetails.ENVELOPE_CAPTIONS[option['envelope_option_index']] = option['envelope_option_captions'];
    });
}

// Format Icon CSS Classnames
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES = {};
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES[
  M.FormatOptions.FLAT] = 'flatFormatIcon';
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES[
  M.FormatOptions.FOLDED_BLANK] = 'foldedBlankFormatIcon';
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES[
  M.FormatOptions.FOLDED_TEXT] = 'foldedMessageFormatIcon';
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES[
  M.FormatOptions.YEARLINE] = 'yearlineFormatIcon';

// Format Icon CSS Classnames for placecards (PLC)
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES_PLACECARDS = {};
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES_PLACECARDS[
  M.FormatOptions.FLAT] = 'flatFormatIconPlacecard';
M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES_PLACECARDS[
  M.FormatOptions.FOLDED_BLANK] = 'foldedBlankFormatIconPlacecard';

// Paper Option DOM IDs
M.View.ProductDetails.PAPER_DOM_IDS = {};
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.SIGNATURE] = 'paperSignature';
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.SIGNATURE80] = 'paperSignature80';
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.RECYCLED_PAPER] = 'paperRecycled';
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.PEARLESCENT] = 'paperPearlescent';
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.TRIPLE_THICK] = 'paperTripleThick';
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.SMOOTH_SIGNATURE] = 'paperSmoothSignature';
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.MUSEUM_BOARD] = 'paperTripleThick';
M.View.ProductDetails.PAPER_DOM_IDS[
  M.Model.ProductDetails.RECYCLED_SMOOTH_SIGNATURE] = 'paperRecycledSmoothSignature';

// Paper Option Captions
// Although this copy is very static, we need to keep these descriptions in
// sync with the ones used on the PHP PDP. It pulls the captions from
// Drupal nodes.
M.View.ProductDetails.PAPER_CAPTIONS = {};
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.SIGNATURE] = 'The thick, luxurious heritage stock ' +
  'that Minted has offered for over a decade, our Signature Paper has a versatile ' +
  'off-white hue and velvety cotton texture. The perfect all-around paper, it is ' +
  'crafted exclusively for Minted by the papermakers at Mohawk, FSC-certified, carbon ' +
  'neutral, and manufactured with wind power. 130 lb., 19.3point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.SIGNATURE80] = 'With a soft cotton texture, this ' +
  'slightly lighter-weight version of our Signature Paper is specially designed ' +
  'for a clean score and fold. It is FSC-certified and manufactured for us by ' +
  'the papermakers at Mohawk using a carbon-neutral process with wind power. ' +
  '80lb., 10 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.STRATHMORE] = 'With a soft cotton texture, our Standard ' +
  'Cover is specially designed in a weight and thickness that results in a ' +
  'clean score and fold. This lighter-weight version of our Signature paper is ' +
  'FSC-certified and using a carbon-neutral process with wind power. ' +
  '100 lb., 14.5 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.RECYCLED_PAPER] = 'The original recycled paper that we\'ve ' +
  'offered for more than a decade is made from 100% post-consumer waste, FSC-certified, ' +
  'and manufactured using a carbon-neutral process with wind power. Crafted by the ' +
  'papermakers at Mohawk, our Recycled Paper is thick and smooth to the touch, with ' +
  'a matte finish. 160 lb., 17.5 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.PEARLESCENT] = 'Add a subtle shimmer to your cards and a ' +
  'soft glow to photographs with our Pearlescent Paper. Perfect for holiday cards, ' +
  'wedding stationery, and personal stationery, it has a luminous finish, is made ' +
  'with 30% post-consumer waste, and is Green Seal™ Certified. 110 lb., 14.5 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.TRIPLE_THICK] = 'Our thickest paper—now recycled from 100% ' +
  'post-consumer waste, FSC-certified, and manufactured using a carbon-neutral process ' +
  'with wind power—is luxuriously heavy weight and virtually unbendable. Our TripleThick™ ' +
  'Paper is crafted from three layers of paper by the papermakers at Mohawk and features ' +
  'a smooth, matte finish. 480 lb., 52.5 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.SMOOTH_SIGNATURE] = 'Optimized for the highest photo print ' +
  'quality, our double-sided Smooth Signature Paper has a smooth front surface that ' +
  'is ideal for printing crisp photos, and the creamy cotton texture of our Signature ' +
  'Paper on the back. It is FSC-certified and manufactured exclusively for Minted by ' +
  'the papermakers at Mohawk using a carbon-neutral process with wind power. ' +
  '137 lb., 17.5 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.MUSEUM_BOARD] = 'Our thickest paper—now recycled from 100% ' +
  'post-consumer waste, FSC-certified, and manufactured using a carbon-neutral process ' +
  'with wind power—is virtually unbendable and luxuriously heavy weight, making it the ' +
  'ultimate choice for a significant event. Our Luxe Museum Board is crafted from three ' +
  'layers of paper by the papermakers at Mohawk and features a smooth, matte finish. ' +
  '480 lb., 52.5 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.MAGNET] = 'Optimized for the highest photo print quality, ' +
  'this stock has a smooth front surface and a magnetized back. Our Smooth Signature ' +
  'Paper is crafted exclusively for Minted by the papermakers at Mohawk. 137 lb., 17.5 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.SOMERSET_500] = 'Luxuriously thick with a feathery ' +
  'cotton texture, our Premium 100% Cotton Paper is designed to take on ' +
  'beautiful, deep letterpress impressions. The bright-white color is crisp ' +
  'and vibrant, which allows our rich letterpress inks to really pop. This ' +
  'special paper is mould-made in the United Kingdom from 100% cotton. ' +
  '500 gsm, 40 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.COVENTRY_320] = 'Our lightly textured 100% Cotton Paper, ' +
  'developed for artists and printmakers, has soft fibers that showcase a crisp ' +
  'imprint of even the most intricate designs. It is made in the USA from 100% cotton. ' +
  '320 gsm, 20 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.SOMERSET_320] = 'A placeholder paper description.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.POLY] = 'A high quality, matte paper. Poly Paper ' +
  'has a slight coating, making it durable and resistant to tearing. ' +
  '120 gsm; 7.5 mil. thick';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.CANVAS] = 'A premium quality, blended art canvas ' +
    'with a matte coating. Backdrop Canvas is acid free and fade resistant. ' +
    '380 gsm; 18 mil. thick.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.DOUBLE_THICK] = 'An extra-thick, luxurious recycled paper, ' +
  'our DoubleThick Paper is made from 100% post-consumer waste, FSC-certified, ' +
  'and manufactured using a carbon-neutral process with wind power. It\'s crafted ' +
  'from two layers of cardstock by the papermakers at Mohawk with a smooth-to-the-touch ' +
  'matte finish. 320 lb., 35 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.COTTON_RAG] = '<b>Premium Archival Paper &amp; Framing' +
  '</b><br />' +
  'Museum-quality, cotton rag archival paper with a slight texture ' +
  'and soft white hue. Premium framed art prints are custom fitted with ' +
  'all wood mouldings, an archival backer, UV-plexi glass, bumpers to ' +
  'protect your wall and hanging wire.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.DELUXE_ART] = '<b>Standard Paper &amp; Framing</b><br />' +
  'A thick, matte art paper in a brilliant white hue. ' +
  'Standard framed art prints are custom fitted using plexi glass, ' +
  'a protective backing, bumpers and hanging wire.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.WRAPPING_PAPER] = 'Includes 5 sheets, 20" x 28" each. ' +
  'Made from a luxe matte paper that is of substantial weight ' +
  'yet still easy to wrap with. 60lb. text weight.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.VALUE_COVER] = 'Bright white and smooth to the touch, ' +
  'our Value Cover is FSC-certified and made with 10% post-consumer waste. ' +
  '100 lb., 14 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.SAVOY_BRIGHT_WHITE] = 'Made from pure cotton fibers ' +
  'with a soft, feathery finish, our Luxury Cotton Paper is designed to take ' +
  'on deep letterpress-printed impressions. It is manufactured for us by the ' +
  'papermakers at Mohawk using a carbon-neutral process with wind power. ' +
  '118 lb., 20 point thickness.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.RECYCLED_SMOOTH_SIGNATURE] = 'Optimized for the highest ' +
  'photo print quality and made from 100% post-consumer waste, our double-sided ' +
  'Smooth Signature Paper has a smooth front surface that is ideal for printing ' +
  'crisp photos, and the creamy cotton texture of our Signature Paper on the back. ' +
  'Crafted exclusively for Minted by the papermakers at Mohawk, our Smooth Signature ' +
  'Paper is also FSC-certified, carbon neutral, and manufactured with wind power. ' +
  '137 lb., 18.0 point thickness.';

// Keep in sync with the fabric options in src/py/minted/model/constants.py
// The js constants do not need $$ signs.
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.COTTON_CANVAS_TOPANGA] = 'Versatile standard canvas ' +
    'printed for light use. 6.6 oz., 100% cotton.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.COTTON_CANVAS_65] = 'Smooth linen blend printed for light ' +
    'use. 6.5 oz., 55% linen, 45% cotton.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.COTTON_CANVAS_10] = 'Durable canvas suitable for ' +
  'heavy-weight crafts including tote bags, throw pillows, and other home ' +
  'decor. 9.8 oz. 75% linen, 25% cotton. 54-55” wide.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.COTTON_DUCK] = 'Heavier canvas perfect for light-weight ' +
  'indoor upholstery including throw pillows and drapery. 10 oz. 100% cotton. 60” wide.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.LIGHTWEIGHT_COTTON_SHEETING] = 'Smooth cotton sheeting, printed for light use.' +
    ' 4.5 oz., 100% cotton.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.PREMIUM_COTTON] = 'Versatile, durable cotton printed with a special ' +
    'process for increased color fastness and vibrancy. 7 oz., 100% cotton.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.LUXURY_LINEN] = 'Refined, crisp linen printed with a special process ' +
    'for increased color fastness and vibrancy. Will hold its own in a home with high-end ' +
    'finishings. 7 oz., 100% linen.';
M.View.ProductDetails.PAPER_CAPTIONS[
  M.Model.ProductDetails.LUXURY_LIGHTWEIGHT_LINEN] = 'Loosely woven, highly refined linen printed ' +
  'with a special process for increased color fastness and vibrancy. Light and slightly ' +
  'translucent, perfect for curtains. 5 oz., 100% linen.';


M.View.ProductDetails.PAPER_NAMES = {};
M.View.ProductDetails.PAPER_NAMES[M.Model.ProductDetails.COTTON_RAG] = 'UV-Plexi Glass & Archival Materials';
M.View.ProductDetails.PAPER_NAMES[M.Model.ProductDetails.DELUXE_ART] = 'Standard Plexi & Materials';

// List of static titles and captions for Artist Signatures.
M.View.ProductDetails.NO_SIGNATURE_TITLE = 'No Signature';
M.View.ProductDetails.SIGNATURE_TITLE = 'Artist Signature';
M.View.ProductDetails.STOCK_SIGNATURE_TITLE = 'Artist Authentication';
M.View.ProductDetails.NO_SIGNATURE_CAPTION = '';
M.View.ProductDetails.SIGNATURE_CAPTION = ' - signed in pencil in lower ' +
  'right corner of artwork.';
M.View.ProductDetails.STOCK_SIGNATURE_CAPTION = ' - name written in pencil in lower ' +
  'right corner of artwork.';

// List of product kinds that don't need the TripleThick 'may require extra
// postage' warning.
M.View.ProductDetails.NO_POSTAGE_WARNING_PRODUCT_KINDS = [
  'BSC',
  'RDS'
];

return {
};

});
